// Import Dependencies
import React, { Component } from 'react';
import UrlParam from '~/common/utils/urlParam';
import Centering from '~/common/components/Centering';
import HeaderGroup from '~/common/components/HeaderGroup';
import { SALES_PHONE_NUMBER_FORMATTED } from '~/common/utils/consts';

export default class SignedIn extends Component {
    state = {
        errorMessage: null
    };

    componentDidMount() {
        window.addEventListener('message', this.messageListener);

        // Send a message to the first tab to get info about the flow, etc
        if (window.opener && window.opener !== self) {
            window.opener.postMessage({ action: 'getLmiModalInfo' }, window.location.origin);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.messageListener);
    }

    messageListener = (message) => {
        if (message && message.data && message.data.action && message.data.action === 'lmiModalInfo') {
            // Once the first tab sends info to this tab about the flow, proceed with initialization
            // See /client/common/components/LoginLmiModal/index.js
            const { logInFlow } = message.data;
            try {
                this.initialize(logInFlow);
            } catch (err) {
                this.setState({
                    errorMessage: 'There was a problem loading the message data action.'
                });
            }
        }
    };

    initialize = (logInFlow) => {
        const lmiAuthcode = this.getLmiAuthcode();
        if (lmiAuthcode) {
            this.handleLmiAuthcode(lmiAuthcode, logInFlow);
        } else {
            // User must have just got signed out from the redirect,
            // so now redirect the user back to the login screen
            window.location.href = '/util/login';
        }
    };

    handleLmiAuthcode = (lmiAuthcode = '', logInFlow = '') => {
        if (window.opener && window.opener !== self) {
            window.opener.postMessage({ action: 'getSignedInMessage', lmiAuthcode, logInFlow }, window.location.origin);
        }
    };

    getLmiAuthcode = () => {
        return UrlParam('code', 'alphaNumericOnly', '_-.');
    };

    render() {
        if (this.state.errorMessage) {
            return (
                <Centering>
                    <HeaderGroup>
                        <h1>Error</h1>
                        <h2>{this.state.errorMessage}</h2>
                        <p>If the problem persists, please contact us at {SALES_PHONE_NUMBER_FORMATTED}.</p>
                    </HeaderGroup>
                </Centering>
            );
        }

        return (
            <Centering>
                <HeaderGroup>
                    {this.state.errorMessage}
                    <h1>Loading Account Information</h1>
                    <h2>Please wait while we load your account information.</h2>
                    <p>If this window does not redirect or close automaticlaly, please close it and return to the signup form.</p>
                </HeaderGroup>
            </Centering>
        );
    }
}
